export default "__VITE_ASSET__BzAKJbDh__"